import { render, staticRenderFns } from "./drugInformation.vue?vue&type=template&id=b0b393f0&scoped=true"
import script from "./drugInformation.vue?vue&type=script&lang=js"
export * from "./drugInformation.vue?vue&type=script&lang=js"
import style0 from "./drugInformation.vue?vue&type=style&index=0&id=b0b393f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b393f0",
  null
  
)

export default component.exports